import React, {useEffect} from 'react';
import classes from './SupportContent.module.css';

import TextContent from './TextContent';
import TextList from './TextList';

// aos
import AOS from 'aos';
import "aos/dist/aos.css";


const SupportContent = props => {
    useEffect( () => {
        AOS.init({
            duration: 1500
        })
    })
    return (
        <TextContent
        title={props.title}
        sx={{
            backgroundColor: '#f7faff',
            overflow: 'hidden',
            padding: '30px'
        }}
    >
        <div className={classes.checkList}>
            <ul className={classes.list} >
                {props.data.map((item, index) => (
                    <TextList data-aos={props.aos} key={index}>{item}</TextList>
                ))}
            </ul>

        </div>
    </TextContent>
    )
}

export default SupportContent;